"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.itemCloseStyles = exports.itemBodyStyles = exports.itemIndexStyles = exports.itemHandleStyles = exports.itemStyles = void 0;

var _styledComponents = require("styled-components");

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var draggingStyles = (0, _styledComponents.css)(["background:", ";box-shadow:", ",0 0 1px ", ";&:focus{box-shadow:", ",", ";}"], _tokens["default"].color.white, _tokens["default"].shadow, _tokens["default"].border.color, _tokens["default"].shadow, _tokens["default"].highlight.active.withBorder.boxShadow);
var itemStyles = (0, _styledComponents.css)(["border-radius:", ";display:flex;list-style:none;padding:", " ", " ", " 2px;&:last-child{margin-bottom:0;}&:focus{box-shadow:", ";outline:none;}", ""], _tokens["default"].border.radius, _tokens["default"].space, _tokens["default"].spaceSm, _tokens["default"].space, _tokens["default"].highlight.active.withBorder.boxShadow, function (_ref) {
  var isDragging = _ref.isDragging;
  return isDragging ? draggingStyles : null;
});
exports.itemStyles = itemStyles;
var itemHandleStyles = (0, _styledComponents.css)(["", ";align-items:center;color:", ";display:flex;line-height:1;padding:0 ", " 0 0;"], _stylers["default"].fontSize(3), _tokens["default"].textColor.icon, _tokens["default"].spaceSm);
exports.itemHandleStyles = itemHandleStyles;
var itemIndexStyles = (0, _styledComponents.css)(["", ";align-self:center;background:", ";border-radius:", ";color:", ";flex-shrink:0;height:", ";line-height:", ";margin:0 ", " 0 0;min-width:1.5em;padding:0 2px;text-align:center;"], _stylers["default"].fontSize(), _tokens["default"].color.blackLighten60, _tokens["default"].border.radius, _tokens["default"].color.black, _stylers["default"].spacer(4), _stylers["default"].spacer(4), _tokens["default"].space);
exports.itemIndexStyles = itemIndexStyles;
var itemBodyStyles = (0, _styledComponents.css)(["align-items:center;display:flex;flex-grow:1;min-width:0;"]);
exports.itemBodyStyles = itemBodyStyles;
var itemCloseStyles = (0, _styledComponents.css)(["align-items:center;display:flex;margin-left:", ";"], _tokens["default"].space);
exports.itemCloseStyles = itemCloseStyles;
//# sourceMappingURL=SortableItem.styles.js.map